import { Box, Heading, Text } from '@chakra-ui/react';

const UplaodCertification = () => {
    return (
        <Box
            w={{ base: 'full', lg: 'full' }}
            bg="#1b3b5f"
            p="20px"
            display="flex"
            flexDir="column"
            justifyContent="center"
            minH={{ base: '80px', lg: '120px' }}
            borderRadius="12px">
            <Heading fontSize="18px" lineHeight="18px" color="white" mb=".5rem">
                Upload Certification
            </Heading>
            <Text fontSize="14px" lineHeight="14px" color="#E7E7FF">
                To Explore the power of Obana
            </Text>
        </Box>
    );
};

export default UplaodCertification;
